import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {mixerConnector} from 'react-arc'
import createHOC from '../../../arc/createHOC'
import config from '../../../../config/config'
import ModelWithAuthContainer from '../../../auth/containers/ModelWithAuthContainer'
import {filterARCCONFIG} from '../../../arc/utils'
import React from 'react'

/** DONT FORGET TO :
 [ ] DECLARE YOUR store : config/store.js  -> userMenu
 [ ] ADD MODEL REQUIRED PROPS, in configUserMenu
 [ ] TYPE THEM  const types = {id: PropType.string.isRequired} (for instance
 [ ] IMPORT ARCModel, createHOC, config (for your urls), from where you are in the project (use your IDE)
 **/

/* ACTIONS */



export const USER_MENUS_NAMESPACE = 'USER_MENUS'

export const configUserMenus = {
    name: 'userMenus',
    uppercaseName: USER_MENUS_NAMESPACE,
    modelProps: ['id'],
    collectionProps: [],
    paths: {
        item: config.menus.menu
    },
    headers: {
        "Content-Type": "application/json",
        "X-Auth-Token": ""
    },
    maxPendingRequestsPerReducer: 3,
    requestFetchDelay: 100
}


function create({ menu, ARCConfig }) {
    return fetch(config.menus.menu, {
        method: "post",
        headers: ARCConfig.headers,
        body: JSON.stringify(menu)
    }).then(response => {
        if (response.status === 200 || response.status === 201) {
            return response.json()
        }
        return response.json().then(r => Promise.reject(r))
    })
}

function update({ menu, ARCConfig }) {
    return fetch(config.menus.menu + '/' + menu.id, {
        method: "put",
        headers: ARCConfig.headers,
        body: JSON.stringify(menu)
    }).then(r => r.json())
}

function remove({ menu, ARCConfig }) {
    return fetch(config.menus.menu + '/' + menu.id, {
        method: "delete",
        headers: ARCConfig.headers
    }).then(r => r.json())
}

const types = {
    id: PropTypes.string.isRequired
}

export class UserMenusContainerBase extends ModelWithAuthContainer {

    static defaultProps = {
        ARCConfig: configUserMenus,
    }

    static propTypes = types

    create = (menu) => create({ARCConfig: this.ARCConfig, menu: menu})

    update = (menu) => update({ARCConfig: this.ARCConfig, menu: menu})

    delete = (menu) => remove({ARCConfig: this.ARCConfig, menu: menu})

    render() {
        const Component = this.props.component
        return <Component {...filterARCCONFIG(this.props)}
                          error={this.getError()}
                          isNew={this.isNew()}
                          loaded={this.isLoaded()}
                          update={this.update}
                          delete={this.delete}
                          create={this.create}
                          fetch={()=>this.fetch(this.getParams())}
                          model={this.isLoaded() ? this.getModel() : null}/>
    }

}

const connector = mixerConnector(connect, configUserMenus)
export const UserMenusContainer = connector(UserMenusContainerBase)

const withUserMenus = createHOC({
    Container: UserMenusContainer,
    ARCConfig: configUserMenus
})
withUserMenus.propTypes = types

withUserMenus.defaultProps = {}

export default withUserMenus